import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '@services/analytics.service';
import { Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MetricsInterceptor implements HttpInterceptor {
  private analyticsService = inject(AnalyticsService);
  private router = inject(Router);

  intercept(req: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
    const attributes = {
      method: req.method,
      url: req.url,
      page: this.router.url,
    };
    const onDone = this.analyticsService.trackProcess('api_request', attributes);
    return next.handle(req).pipe(tap(() => onDone()));
  }
}
